import { Component, ViewChild, HostListener } from '@angular/core';
import { Platform, IonRouterOutlet } from '@ionic/angular';
import { MenuController } from '@ionic/angular';
import { ThemeService } from './providers/theme.service';
import { AppConfig } from './providers/app.config';
import { GlobalService } from './providers/global.service';
import { AuthService } from './providers/auth.service';
import { NetworkService } from './providers/network.service';
import { IonicService } from './providers/ionic.service';
import { AuthGuard } from './providers/auth-guard';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html'
})
export class AppComponent {
    rootPage: any;
    message: any;
    private readonly TIMEOUT_SECONDS = 1200; // 20 minutes
    private timeoutSubscription: any;
    closeConfirmationShown: boolean;
    gs = GlobalService; //To access static methods on HTML
    @ViewChild(IonRouterOutlet, { static: true }) routerOutlet: IonRouterOutlet;


    constructor(
        private platform: Platform,
        private menu: MenuController,
        private themeService: ThemeService,
        private as: AuthService,
        private authGuard: AuthGuard,
        private ns: NetworkService,
        private ions: IonicService,
        private globalservice: GlobalService
    ) {
        this.startTimeout();
        this.platform.ready().then(() => {

            

            if (AppConfig.isApp) {
                this.platform.backButton.subscribeWithPriority(0, () => {
                    if (!this.closeConfirmationShown) {
                        this.confirmBeforeExit();
                    }
                });
            }

            this.ns.initializeNetworkEvents();

            this.as.isLoggedin().then(() => {
                if (location.pathname != "/" && this.authGuard.canViewPage(location.pathname))
                    return;
                this.authGuard.navigateToDefaultPage();
            });
        });
    }

    private startTimeout(): void {
        this.clearTimeout();
        this.timeoutSubscription = this.globalservice.startTimeout(this.TIMEOUT_SECONDS)
            .subscribe(() => {
                // Handle logout or any other action on timeout
                this.as.logout();
            });
    }
    ngOnDestroy(): void {
        this.clearTimeout();
    }
    resetTimeout(): void {
        this.globalservice.resetTimeout();
        this.startTimeout();
    }

    private clearTimeout(): void {
        if (this.timeoutSubscription) {
            this.timeoutSubscription.unsubscribe();
        }
        this.globalservice.resetTimeout();
    }
    async confirmBeforeExit() {
        this.closeConfirmationShown = true;
        let alert = await this.ions.alertCtrl.create({
            header: 'Confirm Exit',
            message: 'Do you want to exit?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        this.closeConfirmationShown = false;
                    }
                },
                {
                    text: 'Yes',
                    handler: () => {
                        navigator['app'].exitApp();
                    }
                }
            ]
        });
        await alert.present();
    }

  
}
